import {
  SubscriptionUnavailableData,
  SubscriptionUnavailableType,
} from './SubscriptionUnavailable.types';
import LegalEntityImage from '@assets/images/legal-entity-alert-logo.png';
import NomineeImage from '@assets/images/nominee-alert-logo.png';
import UsTaxPersonImage from '@assets/images/us-tax-person-alert-logo.png';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';
import { ReactNode } from 'react';
import { Link } from '@mui/material';

export const dataByType: Record<
  SubscriptionUnavailableType,
  SubscriptionUnavailableData
> = {
  legal_entity: {
    image: LegalEntityImage,
    title: GlobalIntlSingleton.intl.formatMessage({
      id: 'investment.profile.legalEntity',
    }),
    description: GlobalIntlSingleton.intl.formatMessage(
      {
        id: 'investment.profile.legalEntityAlertDescription',
      },
      {
        email: (chunks: ReactNode[]): ReactNode => (
          <Link href={`mailto:${chunks}`}>{chunks}</Link>
        ),
      }
    ),
  },
  nominee: {
    image: NomineeImage,
    title: GlobalIntlSingleton.intl.formatMessage({
      id: 'investment.profile.nominee',
    }),
    description: GlobalIntlSingleton.intl.formatMessage(
      {
        id: 'investment.profile.nomineeAlertDescription',
      },
      {
        email: (chunks: ReactNode[]): ReactNode => (
          <Link href={`mailto:${chunks}`}>{chunks}</Link>
        ),
      }
    ),
  },
  us_tax_person: {
    image: UsTaxPersonImage,
    title: '',
    description: GlobalIntlSingleton.intl.formatMessage({
      id: 'investment.taxDetails.usTaxNotAllowMessage',
    }),
  },
  personalDetailsLocked: {
    image: NomineeImage,
    title: '',
    description: GlobalIntlSingleton.intl.formatMessage({
      id: 'investment.subscriptionProcessMessage',
    }),
  },
  company_representative: {
    image: NomineeImage,
    title: '',
    description: GlobalIntlSingleton.intl.formatMessage({
      id: 'investment.companyRepresentativeAlertDescription',
    }),
  },
};
